/**
 * Which OTC add-ons may still be suggested on the shipping page.
 *
 * Test Lab kits are capped at one per order (HL-9979). That cap is enforced per row in
 * OTCProductRowV2, which disables "+" on every test-lab row once a kit is in the cart. The
 * pop-up itself, though, was gated only on the length of the suggestion list — so a category
 * whose add-ons are all test-lab (e.g. Chlamydia: STI-Check Complete / STI-Check Basis /
 * HPV-Risikotyp) opened a pop-up in which nothing could be chosen.
 *
 * Drop what can't be added: a mixed category still suggests its addable items, and an
 * all-test-lab list comes back empty, which closes the pop-up — and hides its trigger button —
 * through the existing `length > 0` gate.
 *
 * Only applied to the list as it arrives from the server. A kit added inside an already-open
 * modal is still handled per row by OTCProductRowV2, so rows never vanish mid-session.
 *
 * with the per-country multiple-kits switch on, other kits stay addable, so nothing is dropped.
 */
export const suggestableOtcAddons = <T extends { is_test_lab?: boolean }>(
  addons: T[],
  cartProducts: Array<{ is_test_lab?: boolean; quantity: number }>,
  allowMultipleTestLabKits?: boolean,
): T[] => {
  if (allowMultipleTestLabKits === true) return addons;
  const hasTestLabInCart = cartProducts.some((product) => product.is_test_lab && product.quantity > 0);
  return hasTestLabInCart ? addons.filter((addon) => !addon.is_test_lab) : addons;
};
